import { useEffect } from "react"

export function useWakeLock() {
  useEffect(() => {
    let wakeLock: WakeLockSentinel | null = null

    async function acquire() {
      try {
        if ("wakeLock" in navigator) {
          wakeLock = await navigator.wakeLock.request("screen")
        }
      } catch {
        // Not supported or permission denied — safe to ignore
      }
    }

    acquire()

    const onVisibility = () => {
      if (document.visibilityState === "visible") acquire()
    }
    document.addEventListener("visibilitychange", onVisibility)

    return () => {
      wakeLock?.release().catch(() => {})
      document.removeEventListener("visibilitychange", onVisibility)
    }
  }, [])
}
